import React from 'react';
import PropTypes from 'prop-types';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import { Link, withRouter } from 'react-router';
import _ from 'lodash';

import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import MoreHorizIcon from 'material-ui/svg-icons/navigation/more-horiz';
import IconEdit from 'material-ui/svg-icons/content/create';
import IconDelete from 'material-ui/svg-icons/action/delete';
import Download from 'material-ui/svg-icons/content/font-download';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

import classes from './Person.scss';

import { DetailField } from '../../../components/DetailField/DetailField';
import ContactCard from '../../../components/ContactCard/ContactCard';
import FileTable from '../../../components/FileTable/FileTable';
import { Address } from '../../../components/Address/Address';
import ProjectTable from '../../../components/ProjectTable/ProjectTable';
import TaskList from '../../../components/TaskList';
import ActivityTableEmbed from '../../../components/ActivityTableEmbed/ActivityTableEmbed';
import { renderTabCount } from '../../../helpers/renderTabCount';
import { simplApiUrlPure, simplAvatarUrl } from '../../../api/simplApi';
import FormFileUpload from '../../../components/FormFileUpload/FormFileUpload';
import { getBirthdayFromMeta } from '../../../helpers/getBirthdayFromMeta';

const contactDetailsStrings = require('../../../locales/contactDetails/de.json');
const peopleStrings = require('../../../locales/people/de.json');

class Person extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      alert: null,
      selectedIndex: 0,
    };
  }

  componentWillMount() {
    this.props.setPerson(this.props.params.person);
  }

  componentDidMount() {
    this.props.fetchPerson(this.props.params.person);
  }

  handleSelect = index => {
    this.setState({ selectedIndex: index });
  };

  handleAlertClose = () => {
    this.setState({
      alert: null,
    });
  };

  renderHeader = () => (
    <header>
      <ul className="breadcrumbs">
        <li>
          <Link to="/person" activeClassName={classes.activeRoute}>
            {this.props.personCount} Kontakte
          </Link>
        </li>
        <li>
          {this.props.person.name}
          {this.props.person.deleted_at === null ? (
            ''
          ) : (
            <span className="deletedTag">gelöscht</span>
          )}
        </li>
      </ul>
      <IconMenu
        iconButtonElement={
          <IconButton>
            <MoreHorizIcon />
          </IconButton>
        }
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        targetOrigin={{ horizontal: 'right', vertical: 'top' }}
        className="overflow-right"
      >
        <MenuItem
          primaryText="Kontakt bearbeiten"
          leftIcon={<IconEdit className="svg-icon-primary" />}
          key="editPerson"
          className="menu-primary"
          onClick={() => {
            this.props.setPersonForm(this.props.person.id);
          }}
        />

        <MenuItem
          primaryText="Kontakt löschen"
          leftIcon={
            <IconDelete className="svg-icon-primary svg-icon-warning" />
          }
          key="delPerson"
          className="menu-primary"
          onClick={() => {
            this.setState({
              alert: (
                <Dialog
                  actions={[
                    <FlatButton
                      label="Abbrechen"
                      primary
                      onTouchTap={this.handleAlertClose}
                    />,
                    <FlatButton
                      label="Löschen"
                      primary
                      onTouchTap={() => {
                        this.handleAlertClose();
                        this.props.deletePerson(this.props.person.id); // this.props.push('/person');
                        this.props.router.push('/person');
                      }}
                    />,
                  ]}
                  modal={false}
                  open
                  onRequestClose={this.handleAlertClose}
                >
                  Kontakt wirklich löschen?
                </Dialog>
              ),
            });
          }}
        />

        <MenuItem
          primaryText="Kontakt als PDF exportieren"
          leftIcon={<Download className="svg-icon" />}
          key="downloadPerson"
          className="menu-primary"
          onClick={() => {
            const id =
              typeof this.props.person.simpl_account === 'string'
                ? this.props.person.simpl_account
                : this.props.person.simpl_account.id;
            window.open(
              simplApiUrlPure(
                `export/pdf/person/${id}/${this.props.person.id}/${this.props.person.linkHash}`,
              ),
              '_blank',
            );
          }}
        />
      </IconMenu>
      {this.state.alert}
    </header>
  );
  renderContacts = () => {
    const contacts = [];
    _.forOwn(this.props.persons, value => {
      // create new object that will be handled by griddle
      const email = _.find(value.contact_details, ['type', 'email']);
      const phone = _.find(value.contact_details, ['type', 'tel']);
      const position = _.find(value.meta, ['key', 'position']);
      contacts.push(
        <ContactCard
          name={value.name}
          number={phone ? phone.value : null}
          email={email ? email.value : null}
          position={position ? position.value : null}
          avatar={value.avatar_url}
          key={`contactcard_${value.id}`}
        />,
      );
    });
    if (contacts.length === 0) {
      return <div />;
    }
    return (
      <section>
        <h2>Kontakte</h2>
        <div className="row">{contacts}</div>
      </section>
    );
  };
  renderContactDetails = () => {
    const details = [];
    if (typeof this.props.person.contact_details !== 'undefined') {
      const sortedDetails = _.sortBy(this.props.person.contact_details, [
        'sortedByType',
        'created_at',
      ]);

      sortedDetails.forEach(contactDetail => {
        details.push(
          <DetailField
            label={contactDetailsStrings[contactDetail.type]}
            content={contactDetail.value}
            extra={contactDetail.note}
            key={`contact_detail_person_${contactDetail.id}`}
          />,
        );
      });
    }
    return details;
  };
  renderCompanies = () => {
    if (Object.keys(this.props.companies).length) {
      const companyLinks = [];
      _.forOwn(this.props.companies, company => {
        let name = company.name;
        if (company.deleted_at !== null) {
          name = `${name} (gelöscht)`;
        }

        companyLinks.push(
          <Link
            key={`person_company_link_${company.id}`}
            to={`/company/${company.id}`}
          >
            {name}
          </Link>,
        );
      });
      const container = (
        <div className="col-xs-12 col-sm-9">{companyLinks}</div>
      );
      return <DetailField label="Unternehmen" content={container} />;
    }
    return null;
  };
  renderOverview = () => {
    let address = '';
    if (
      typeof this.props.person.addresses !== 'undefined' &&
      typeof this.props.person.addresses[0] !== 'undefined' &&
      typeof this.props.person.addresses[0].street !== 'undefined' &&
      this.props.person.addresses[0].street !== null &&
      this.props.person.addresses[0].street.length
    ) {
      address = (
        <div className="row overview">
          <div className="col-xs-12 col-sm-3">
            <label>Adresse</label>
          </div>
          <div className="col-xs-12 col-sm-9">
            <Address address={this.props.person.addresses[0]} />
          </div>
        </div>
      );
    }

    const avatar = simplAvatarUrl(
      'person',
      this.props.person.id,
      128,
      128,
      'crop',
    );

    return (
      <div>
        <section>
          <h2>Allgemein</h2>
          <div className={classes.peopleMainInfo}>
            <div className={classes.peopleMainInfoLeft}>
              <DetailField
                label="Titel"
                content={this.props.person.meta.salutation}
              />
              <DetailField label="Name" content={this.props.person.name} />
              {this.renderCompanies()}
              <DetailField
                label="Position"
                content={this.props.person.meta.position}
              />
              <DetailField
                label="Geschlecht"
                content={
                  this.props.person.meta.gender
                    ? peopleStrings[this.props.person.meta.gender.value]
                    : null
                }
              />
              <DetailField
                label="Geburtstag"
                content={getBirthdayFromMeta(this.props.person.meta, true)}
              />
              <DetailField
                label="Bemerkungen"
                content={this.props.person.meta.notes}
                className="notes"
              />
            </div>
            <div className={classes.peopleMainInfoRight}>
              <img src={avatar} alt={this.props.person.name} />
            </div>
          </div>
        </section>

        <section>
          <h2>Anschrift & Kommunikation</h2>

          {address}
          {this.renderContactDetails()}
        </section>
      </div>
    );
  };
  render() {
    if (
      !this.props.person ||
      Object.keys(this.props.person).length === 0 ||
      typeof this.props.person === 'undefined'
    ) {
      // no data loaded yet
      return <div />;
    }
    Tabs.setUseDefaultStyles(false);
    const person = this.props.person;
    return (
      <div
        className={
          this.props.person.deleted_at === null
            ? 'wrapper details-view'
            : 'wrapper details-view deletedModel'
        }
      >
        {this.renderHeader()}
        <Tabs
          onSelect={this.handleSelect}
          selectedIndex={this.state.selectedIndex}
          className="content"
        >
          <TabList activeTabClassName="active">
            <Tab>
              <span>Details</span>
            </Tab>
            <Tab>
              <span>Aktivitäten {renderTabCount(this.props.activities)}</span>
            </Tab>
            <Tab>
              <span>Projekte {renderTabCount(person.projects)}</span>
            </Tab>
            <Tab>
              <span>Aufgaben {renderTabCount(this.props.tasks)}</span>
            </Tab>
            <Tab>
              <span>Dateien {renderTabCount(this.props.files)}</span>
            </Tab>
          </TabList>

          <TabPanel>{this.renderOverview()}</TabPanel>
          <TabPanel>
            <ActivityTableEmbed
              activities={this.props.activities}
              staffs={this.props.staffs}
            />
          </TabPanel>
          <TabPanel>
            <section>
              <h2>{renderTabCount(person.projects, true)} Projekte</h2>
            </section>
            <section className="no-padding">
              <ProjectTable projects={this.props.projects} />
            </section>
          </TabPanel>
          <TabPanel>
            <section>
              <h2>{renderTabCount(this.props.tasks, true)} Aufgaben</h2>
            </section>
            <TaskList
              tasks={this.props.tasks}
              showTaskForm
              taskableType="person"
              taskableId={this.props.person.id}
              showFutureDates
            />
          </TabPanel>
          <TabPanel>
            <section>
              <h2>{renderTabCount(this.props.files, true)} Dateien</h2>
            </section>
            <section className="no-padding">
              <FileTable
                files={this.props.files}
                deleteFile={this.props.deleteFile}
              />
            </section>
          </TabPanel>
        </Tabs>

        <FormFileUpload
          attachableId={this.props.person.id}
          attachableType="App\Person"
          files={[]}
          onUpdate={() => {
            this.props.fetchPerson(this.props.person.id);
          }}
          invisible
          disabled={this.props.formOpen}
        />
      </div>
    );
  }
}
Person.propTypes = {
  fetchPerson: PropTypes.func.isRequired,
  setPerson: PropTypes.func.isRequired,
  setPersonForm: PropTypes.func.isRequired,
  deletePerson: PropTypes.func.isRequired,
  deleteFile: PropTypes.func.isRequired,
  push: PropTypes.func.isRequired,
  person: PropTypes.object,
  personCount: PropTypes.number,
  activities: PropTypes.array.isRequired,
  files: PropTypes.array,
  staffs: PropTypes.array,
  companies: PropTypes.array,
  tasks: PropTypes.array,
  projects: PropTypes.array,
  persons: PropTypes.array,
  params: PropTypes.object,
  router: PropTypes.object,
  formOpen: PropTypes.bool,
};
Person.defaultProps = {
  person: {},
  personCount: 0,
  files: {},
  staffs: {},
  companies: {},
  tasks: {},
  projects: {},
  persons: {},
  params: {},
};
export default withRouter(Person);



// WEBPACK FOOTER //
// ./src/routes/PersonDetail/components/Person.js